import SlsUfClient from '@/api/Cadastros/Gerais/sls-uf.client';

import { ErrorMessage } from '@/libs/Error';

export default class SLSUfService {
  constructor() {
    this.client = new SlsUfClient();
    this.error = new ErrorMessage();
  }

  async index(queries) {
    try {
      const { data } = await this.client.index(queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os uf');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.client.store(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao criar Uf');
    }
  }

  async show(id) {
    try {
      const { data } = await this.client.show(id);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Uf');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.client.update(id, data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar Uf');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.client.destroy(id);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Uf');
    }
  }
}
